var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckRound = function SvgIconCheckRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009DE7",
    fillRule: "evenodd",
    d: "M12 21.6a9.6 9.6 0 0 0 9.6-9.6c0-5.302-4.298-9.6-9.6-9.6S2.4 6.698 2.4 12a9.6 9.6 0 0 0 9.6 9.6m5.835-12.727a.89.89 0 0 0-1.26 0l-5.927 5.926-3.012-3.012a.892.892 0 0 0-1.26 1.26l3.384 3.385c.49.49 1.286.49 1.776 0l6.299-6.299a.89.89 0 0 0 0-1.26",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckRound;